import RecommendedConsultantCard from './RecommendedConsultantCard';
export default RecommendedConsultantCard;